<div class="sidebar-brand">
  <img src="normax-2.png" alt="Normax Capital" style="height: 38px; width: auto; object-fit: contain;" />
  <div class="sidebar-brand-subtitle">CRM &middot; Static reference</div>
</div>
<nav class="sidebar-nav">
  <a [routerLink]="['/static']" class="sidebar-link" [class.active]="activeKey() === ''">
    <span>All reference pages</span>
  </a>
  @for (cluster of nav; track cluster.cluster) {
    <div class="sidebar-cluster">
      <div class="sidebar-cluster-label">{{ cluster.cluster }}</div>
      @for (item of cluster.items; track item.key) {
        <a
          [routerLink]="['/static', item.path]"
          class="sidebar-link"
          [class.active]="item.key === activeKey()"
          [attr.data-key]="item.key"
        >
          <span class="sidebar-link-icon" [innerHTML]="iconFor(item.key) | safeHtml"></span>
          <span>{{ item.label }}</span>
        </a>
      }
    </div>
  }
</nav>
<div class="sidebar-footer">
  <a [routerLink]="['/dashboard']" class="sidebar-footer-link">&larr; Back to live app</a>
  <div class="sidebar-footer-entity">{{ user().entity }}</div>
  Reg. 969798-7692
</div>
